import axios from "axios";

const instance = axios.create({
  baseURL: "https://amazon-clone-demo.herokuapp.com",
});

export default instance;
